import React from "react";
import "./WhyLehumo.css";
import { Link } from "react-router-dom";

import Crypto from "../assets/trade-2.png";

const WhyLehumo = () => {
  return (
    <div className="signup" id="about">
      <div className="container">
        {/* left */}
        <div className="left">
          <img src={Crypto} alt="" />
        </div>

        {/* right */}
        <div className="right">
          <h2>Why Lehumo?</h2>
          <p>
            The Lehumo model has since led the way as South Africa’s top index
            tracking instrument of the crypto asset sector and is functionally
            synonymous with exchange-traded funds (ETFs).
          </p>
          <p>
            Lehumo harnesses a secure custody solution to ensure the highest
            level of digital security.
          </p>
          <div className="input-container">
            <Link to="/Company">
              <button className="btn">Learn More</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyLehumo;
